var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXmarkBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.861894 0.862383C1.28383 0.440573 1.85602 0.203613 2.45264 0.203613C3.04926 0.203613 3.62146 0.440573 4.04339 0.862383L11.9994 8.81838L19.9554 0.862383C20.3797 0.452527 20.9481 0.22574 21.538 0.230866C22.128 0.235993 22.6923 0.472623 23.1095 0.889791C23.5267 1.30696 23.7633 1.87129 23.7684 2.46123C23.7735 3.05117 23.5467 3.61953 23.1369 4.04388L15.1809 11.9999L23.1369 19.9559C23.5467 20.3802 23.7735 20.9486 23.7684 21.5385C23.7633 22.1285 23.5267 22.6928 23.1095 23.11C22.6923 23.5271 22.128 23.7638 21.538 23.7689C20.9481 23.774 20.3797 23.5472 19.9554 23.1374L11.9994 15.1814L4.04339 23.1374C3.61904 23.5472 3.05068 23.774 2.46074 23.7689C1.8708 23.7638 1.30647 23.5271 0.889303 23.11C0.472134 22.6928 0.235504 22.1285 0.230378 21.5385C0.225251 20.9486 0.452039 20.3802 0.861894 19.9559L8.81789 11.9999L0.861894 4.04388C0.440084 3.62195 0.203125 3.04975 0.203125 2.45313C0.203125 1.85651 0.440084 1.28432 0.861894 0.862383Z",
    fill: "#B33636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmarkBig);
export default __webpack_public_path__ + "static/media/xmark-big.0e0c13102e0ee0a3079348b7afb174ec.svg";
export { ForwardRef as ReactComponent };